import axios from "axios";
import { errorMessage, tokenExpired, errorAlert } from "@/api/errorMessages";
import * as api from "@/api/oauth";

export default {
  namespaced: true,
  state: {
    route: null,
    trailerSelectedInfo: [],
    infoTableOversize: null
  },
  getters: {
    showRoute(state) {
      return state.route;
    },
    showTrailerSelectedInfo(state) {
      return state.trailerSelectedInfo;
    }
  },
  mutations: {
    setRoute(state, newRoute) {
      state.route = newRoute;
    },
    // ! Mutation que agrega value ingresado por el usuario.
    setTrailerSelectedInfo(state, trailerInfo) {
      for (let i in trailerInfo) {
        state.trailerSelectedInfo[i] = trailerInfo[i];
      }
    },
    setInitTrailerSelectedInfo(state, lenght) {
      for (let i = 0; i < lenght; i++) {
        state.trailerSelectedInfo.push({
          trailerType: null
        });
      }
    }
  },
  actions: {
    async calculateRoute({ commit }, info) {
      try {
        let response = await axios.post(
          process.env.VUE_APP_BACK_ROUTE + `/api/route/${info.quoteId}/`,
          info.calculateForm
        );
        let routeAux;
        if (response.status == 200) {
          routeAux = response.data;
          routeAux.id = info.quoteId;
        }
        commit("setRoute", routeAux);
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },

    async getDat(__, info) {
      try {
        let response = await axios.get(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/dat?haul_id=${info.haulId}&equipmentType=${info.equipment_type}&city_origin=${info.city_origin}&postalCode_origin=${info.postalCode_origin}&country_origin=US&city_destination=${info.city_destination}&postalCode_destination=${info.postalCode_destination}&country_destination=${info.country_destination}`
        );
        if (response.status == 200) {
          return response;
        }
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },

    async getRateIq(__, info) {
      try {
        let response = await axios.get(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/rate-iq?mode_id=${info.mode_id}&haul_id=${info.haulId}&city_to=${info.city_to}&state_to=${info.state_to}&zipCode_to=${info.zipCode_to}&country_to=${info.country_to}&city_from=${info.city_from}&state_from=${info.state_from}&zipCode_from=${info.zipCode_from}&country_from=${info.country_from}`,
          api.getToken()
        );
        if (response.status == 200) {
          return response;
        }
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err?.response?.data?.detail) {
          errorAlert("There is something wrong", err?.response?.data?.detail);
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    }
  }
};
